import { Link, useLocation } from "react-router-dom";
import PageShell from "@/components/feature/PageShell";

export default function NotFound() {
  const location = useLocation();

  return (
    <PageShell>
      <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-8 md:py-32">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-background-200 text-primary-700">
          <i className="ri-emotion-sad-line text-4xl" />
        </span>
        <h1 className="mt-6 font-heading text-5xl font-black tracking-tight text-primary-700 md:text-7xl">
          404
        </h1>
        <p className="mt-4 font-heading text-lg font-bold text-foreground-950">
          页面走丢了
        </p>
        <p className="mt-2 text-sm font-mono text-foreground-500">{location.pathname}</p>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面不存在或已被移除，可以返回首页，或前往电影 / 电视剧分类继续浏览影视资料。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-600"
          >
            <i className="ri-home-line text-base" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-search-line text-base" />
            去搜索
          </Link>
        </div>
      </div>
    </PageShell>
  );
}